import { MARQUEE_ITEMS } from "@/data/products";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="marquee-band"
      className="bg-ink-deep border-y border-gold/30 py-7 overflow-hidden"
    >
      <div className="marquee-track">
        {items.map((t, i) => (
          <div
            key={i}
            className="flex items-center px-10 whitespace-nowrap text-gold-light font-serif italic text-2xl md:text-3xl"
          >
            {t}
            <span className="ml-10 text-gold text-2xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
